module.exports = __webpack_public_path__ + "static/media/quarteto_coliseu_2.0b73017c.jpg";